import { render, staticRenderFns } from "./money-saving-ui.mpx?vue&type=template&id=2c43f5f2&scoped=true&component=true&componentId=money-saving-ui34d96f6a"
import script from "./money-saving-ui.mpx?vue&type=script&lang=js&component=true&componentId=money-saving-ui34d96f6a"
export * from "./money-saving-ui.mpx?vue&type=script&lang=js&component=true&componentId=money-saving-ui34d96f6a"
import style0 from "./money-saving-ui.mpx?vue&type=style&index=0&id=2c43f5f2&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m34d96f6a%22%7D&component=true&componentId=money-saving-ui34d96f6a"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c43f5f2",
  null
  
)

export default component.exports